import { Badge, BadgeProps, Text } from "@chakra-ui/react";

type SupplyBadgeProps = {
  current: number;
  max: number;
} & BadgeProps;

const SupplyBadge = ({
  current,
  max,
  size = "md",
  ...rest
}: SupplyBadgeProps) => {
  const isSoldOut = current >= max;

  return (
    <Badge
      borderRadius="full"
      fontWeight="semibold"
      bg={isSoldOut ? "primary.500" : "dark.700"}
      color="bright.50"
      px="1.5"
      fontSize={size === "sm" ? "0.625rem" : undefined}
      {...rest}
    >
      <Text as="span" color="primary.500">
        {isSoldOut ? "S" : `${current + 1} `}
      </Text>
      <Text as="span" fontWeight="normal" color="dark.100">
        /
      </Text>
      {isSoldOut ? "O" : ` ${max}`}
    </Badge>
  );
};

export default SupplyBadge;
